import { render } from "./PositionContent.vue?vue&type=template&id=4fb6b2ee"
import script from "./PositionContent.vue?vue&type=script&lang=js"
export * from "./PositionContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__